import { CsvButton } from '@components/Buttons/CsvButton';
import { LinkText } from '@components/LinkText';
import { Pagination } from '@components/Table/Pagination';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IPagamentoFilter, IPagamentoRecord } from '@services/RelatorioService';
import React from 'react';

export type PagamentoTableProps = {
    data: IData<IPagamentoRecord, IPagamentoFilter>
    isLoading: boolean
    onCsvButtonClick: VoidFunction
}

export function PagamentoTable ({ data, onCsvButtonClick, isLoading }: PagamentoTableProps) {
    const formatter = useFormatter();

    return (
        <React.Fragment>
            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <Pagination pagination={data.pagination}>
                        <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                    </Pagination>

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="faturaPagamentoId">Pagamento ID</TableSortCell>
                        <TableSortCell fieldName="faturaId">Fatura ID</TableSortCell>
                        <TableSortCell fieldName="usuario.nome">Usuário</TableSortCell>
                        <TableSortCell fieldName="fatura.datavencimento">Vencimento</TableSortCell>
                        <TableSortCell fieldName="formaPagamento.nome">Forma Pagamento</TableSortCell>
                        <TableSortCell fieldName="dataHora">Data/Hora</TableSortCell>
                        <TableSortCell fieldName="fatura.cliente.nome">Cliente</TableSortCell>
                        <TableSortCell fieldName="fatura.cliente.cpf">CPF</TableSortCell>
                        <TableSortCell fieldName="fatura.empresa.nome">Empresa</TableSortCell>
                        <TableSortCell fieldName="valor">Valor</TableSortCell>
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((pagamentoRecord, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell>{pagamentoRecord.faturaPagamentoId}</TableKeyCell>
                                    <TableCell>{pagamentoRecord.faturaId}</TableCell>
                                    <TableCell>{pagamentoRecord.usuario.nome}</TableCell>
                                    <TableCell>{formatter.toDate(pagamentoRecord.fatura.dataVencimento)}</TableCell>
                                    <TableCell>{pagamentoRecord.formaPagamento.nome}</TableCell>
                                    <TableCell>{formatter.toDateTime(pagamentoRecord.dataHora)}</TableCell>
                                    <TableCell><LinkText to={`/cliente/${pagamentoRecord.fatura.cliente.clienteId}`} text={pagamentoRecord.fatura.cliente.nome} /></TableCell>
                                    <TableCell>{pagamentoRecord.fatura.cliente.cpf}</TableCell>
                                    <TableCell>{pagamentoRecord.fatura.empresa.nome}</TableCell>
                                    <TableCell>{formatter.toFloat(pagamentoRecord.valor)}</TableCell>
                                </TableRow>
                            )
                        })
                    }

                    <Pagination pagination={data.pagination}>
                        <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                    </Pagination>

                </TableBody>
            </TableNoResult>
        </React.Fragment>
    )
}